import { render, staticRenderFns } from "./drafts.vue?vue&type=template&id=0e0650fd&scoped=true&"
import script from "./drafts.vue?vue&type=script&lang=js&"
export * from "./drafts.vue?vue&type=script&lang=js&"
import style0 from "./drafts.vue?vue&type=style&index=0&id=0e0650fd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0650fd",
  null
  
)

export default component.exports